import React from "react";
import { AnalyticsCard, AnalyticsTable, Cell, ColumnDef, TABLE_MIN_HEIGHT, TableFooter } from "../../common";
import { useInteractionsQuery } from "src/query/experiences/leadsAndReports/reports";
import { useTableState } from "../../hooks/useTableState";

interface InteractionAnalyticsProps {
  storyboardId: string;
}

const COLUMNS: ColumnDef[] = [
  { key: "name", header: "Name" },
  { key: "clicks", header: "Clicks", align: "center" },
  { key: "leads", header: "Leads", align: "center" },
];

export const InteractionAnalytics: React.FC<InteractionAnalyticsProps> = ({ storyboardId }) => {
  const { request, key, page, setPage, chart, enabled } = useTableState(storyboardId);
  const { data, isLoading } = useInteractionsQuery(request, key, page, enabled);
  const rows = data?.records ?? [];
  const paginated = (data?.totalPages ?? 1) > 1;

  return (
    <AnalyticsCard
      title="Interaction Analytics"
      count={data?.totalRecordsCount ?? rows.length}
      footer={
        <TableFooter
          currentChart={chart}
          handlePageChange={setPage}
          pagination={data}
          paginationName="Interactions"
        />
      }
    >
      <AnalyticsTable
        variant="split"
        columns={COLUMNS}
        rows={rows}
        loading={isLoading}
        contentMinHeight={paginated ? TABLE_MIN_HEIGHT.split : undefined}
        renderRow={(row: any) => (
          <>
            <Cell headline={row.name} />
            <Cell headline={row.interactions} />
            <Cell headline={row.visitors} />
          </>
        )}
      />
    </AnalyticsCard>
  );
};
